/**
 * Разбивает массив на подмассивы длиной не более `size`. Пустой вход или
 * неположительный размер дают пустой либо цельный результат без исключений —
 * удобно для пакетной отправки больших списков (10k позиций) частями.
 */
export function chunk<T>(items: T[], size: number): T[][] {
  if (size <= 0) return items.length > 0 ? [items.slice()] : [];
  const result: T[][] = [];
  for (let i = 0; i < items.length; i += size) {
    result.push(items.slice(i, i + size));
  }
  return result;
}
